import { render, staticRenderFns } from "./tixianDialog.vue?vue&type=template&id=2369cc57&scoped=true"
import script from "./tixianDialog.vue?vue&type=script&lang=js"
export * from "./tixianDialog.vue?vue&type=script&lang=js"
import style0 from "./tixianDialog.vue?vue&type=style&index=0&id=2369cc57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2369cc57",
  null
  
)

export default component.exports